'use client'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import LogoField from './fields/logo-field'

export default function LogoForm({ form, formStep, nextButtonClick }) {
  const logoImgValue = form.watch('logoImg')

  return (
    <div
      className={cn('flex h-full w-full flex-col justify-center gap-5 pb-6', {
        hidden: formStep !== 1,
      })}
    >
      <div className="flex h-full grow flex-col justify-between gap-6">
        <LogoField form={form} />
        <div className="flex justify-start gap-2">
          <Button variant="outline" type="button" onClick={nextButtonClick}>
            Do it later
          </Button>
          <Button
            type="button"
            disabled={!logoImgValue}
            onClick={nextButtonClick}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}
